








import { RealworksStatusRule } from '@/api/model/realworks-status-rule'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class CreatePhaseStatusVerticalStep4 extends Vue {
    @Prop( { required: true }) readonly currentStep!: number
    @Prop( { required: true }) readonly value!: RealworksStatusRule
}
